
// ============================================================
// PATISSORA — CENTRAL DATA FILE
// 📁 src/constants/data.js
// ============================================================

// ── 1. SITE CONFIG ──────────────────────────────────────────
export const SITE_CONFIG = {
    brandName: 'Patissora',
    tagline: 'Cake & Custom House',
    slogan: 'Where Cakes Become Art',
    established: '2026',
    location: 'Karachi, Pakistan',
    whatsapp: '923052609077',
    whatsappDisplay: '+92 305 2609077',
    instagram: 'https://www.instagram.com/patissoracake',
    facebook: 'https://www.facebook.com/profile.php?id=61575394351266&mibextid=wwXIfr&rdid=OZDsLpwMeeoJDWMr&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1D6suft94W%2F%3Fmibextid%3DwwXIfr%26ref%3D1#',
    instagramHandle: '@patissoracake',
    facebookPage: 'Patissora - Cake & Custom House',
    currency: 'PKR',
};

// ── 2. CATEGORIES ────────────────────────────────────────────
export const CATEGORIES = [
    'All',
    'Signature Cake',
    'Classic Collection',
    'Custom Order',
    'Seasonal Special',
];


// NOTE: The CAKES array used to be hardcoded here. Cakes now live in
// MongoDB and are managed from the admin dashboard (Admin -> Cakes),
// then fetched at runtime via src/lib/api.js. See Home.jsx / CakeDetail.jsx.

// ── 4. WHY US ─────────────────────────────────────────────────
// icon: react-icons/fa key — rendered in Home.js via WHY_ICONS map
export const WHY_US = [
    {
        icon: 'FaBirthdayCake',
        title: 'Custom Designed',
        description:
            'Every cake is built around your vision — no two cakes are ever the same.',
    },
    {
        icon: 'FaStar',
        title: 'Premium Ingredients',
        description:
            'We use only the finest Belgian chocolate, fresh cream and natural flavours.',
    },
    {
        icon: 'FaBox',
        title: 'Karachi Delivery',
        description:
            'Fresh, on-time delivery across Karachi with careful packaging.',
    },
    {
        icon: 'FaWhatsapp',
        title: 'WhatsApp Orders',
        description:
            'Easy ordering via WhatsApp. Chat with us and we handle the rest.',
    },
];

// ── 5. CONTACT INFO ───────────────────────────────────────────
// icon: react-icons/fa key — rendered in Contact.js via CONTACT_ICONS map
export const CONTACT_INFO = [
    {
        icon: 'FaMapMarkerAlt',
        label: 'Location',
        value: 'Karachi, Pakistan',
        sub: 'Delivery available across Karachi',
        link: null,
    },
    {
        icon: 'FaWhatsapp',
        label: 'WhatsApp',
        value: '+92 305 2609077',
        sub: 'Available 10am – 10pm daily',
        link: `https://wa.me/${SITE_CONFIG.whatsapp}`,
    },
    {
        icon: 'FaInstagram',
        label: 'Instagram',
        value: '@patissoracake',
        sub: 'Follow us for daily cake inspiration',
        link: SITE_CONFIG.instagram,
    },
    {
        icon: 'FaFacebookF',
        label: 'Facebook',
        value: 'Patissora - Cake & Custom House',
        sub: 'Like our page for updates & offers',
        link: SITE_CONFIG.facebook,
    },
];

// ── 6. MARQUEE TEXT ──────────────────────────────────────────
export const MARQUEE_ITEMS = [
    'Custom Cakes',
    'Signature Cakes',
    'Birthday Cakes',
    'Wedding Cakes',
    'Karachi Delivery',
    'Crafted with Love',
];
